import { IEntry } from './IEntry';
import { NEWS_ALERT_TYPE_ID } from '../constants';

export enum NewsAlertDisplayOn {
	IAH = 'IAH',
	HOU = 'HOU',
	EFD = 'EFD',
	Spaceport = 'Spaceport',
	Corporate = 'HAS Corporate',
	Gateway = 'Gateway page',
}

export interface INewsAlert {
	title: string;
	body: string;
	type: string;
	link?: string;
	displayOn?: NewsAlertDisplayOn[];
}

export interface INewsAlertEntry
	extends IEntry<INewsAlert, typeof NEWS_ALERT_TYPE_ID> {}
